
export function pprint(...data: any[]) {
	console.log(...data)
}
